import posthog from "posthog-js";
import {
  getReploRootCookieDomain,
  REPLO_ACCOUNT_HINT_COOKIE,
} from "schemas/cookies";

const clearAccountHintCookie = () => {
  // Expire both the apex-scoped (production) and host-only (localhost) variants.
  const apexDomain = getReploRootCookieDomain(window.location.hostname);
  if (apexDomain) {
    document.cookie = `${REPLO_ACCOUNT_HINT_COOKIE}=; domain=${apexDomain}; path=/; max-age=0`;
  }
  document.cookie = `${REPLO_ACCOUNT_HINT_COOKIE}=; path=/; max-age=0`;
};

export const storeToken = (token: string | null) => {
  const previousToken = localStorage.getItem("andytown__token2");
  // Sign-out and account swaps (Log-in-as enter/exit) start a fresh PostHog person; a first sign-in keeps the anonymous history.
  if (posthog.__loaded && previousToken && previousToken !== token) {
    posthog.reset();
  }
  if (!token) {
    localStorage.removeItem("andytown__token2");
    clearAccountHintCookie();
  } else {
    localStorage.setItem("andytown__token2", token);
  }
};

/** A new token for the same user (password change) keeps the PostHog person. */
export const refreshStoredToken = (token: string) => {
  localStorage.setItem("andytown__token2", token);
};
